import React from 'react'
import styled from 'styled-components'
import FullScreenHeightImage, {
  FullScreenImageContainer,
} from '../FullScreenHeightImage/FullScreenHeightImage'
import VerticalSlider from './VerticalSlider'

const StyledVerticalSlider = styled(VerticalSlider)`
  position: relative;
  height: 100%;
`

interface IProps {
  images: string[]
  scrollable?: boolean
  className?: string
}

const FullHeightVerticalSlider: React.FC<IProps> = props => {
  return (
    <FullScreenImageContainer className={props.className}>
      <StyledVerticalSlider
        scrollable={props.scrollable}
        controlPlacement={'left-center'}
      >
        {props.images.map((url, index) => {
          return <FullScreenHeightImage key={index} src={url} />
        })}
      </StyledVerticalSlider>
    </FullScreenImageContainer>
  )
}

export default FullHeightVerticalSlider
